<template lang="pug">
include ../pug/svg
div.block(:class="[block.type, block.subtype]" @mouseleave="focus=null")
	contenteditable(tag="div" :spellcheck="(focus===1)" :class="{fade:focus}" v-model="block.content.onecolumn" :noNL="false" @focus="focus=1" @blur="focus=null" @keyup="blockUpdated")
	p
		contenteditable(tag="strong" :spellcheck="(focus===2)" :class="{fade:focus&&focus!==2}" v-model="block.content.subheaded" :noNL="true" @focus="focus=2" @blur="focus=null" @keyup="blockUpdated")
	div.modal.settings(v-if="block.settings.active" @mouseleave="toggleSettings()")
		ModalBar(label="Block Settings" :useDrag="true" @close="toggleSettings()")
		pre {{block.settings}}
</template>

<script>
import contenteditable from 'vue-contenteditable';
import ModalBar from '../components/ModalBar';

export default {
	name: 'BlockTextQuote',
	props:['block'],
	emits: ['blockUpdated', 'toggleSettings'],
	components: {
		contenteditable,
		ModalBar,
	},
	data() {
		return {
			focus: null,
		}
	},
	methods: {
		blockUpdated() {
			this.$emit('blockUpdated');
		},
		toggleSettings() {
			this.$emit('toggleSettings', this.block);
		},
	},
}
</script>

<style lang="scss">
.quote {}
</style>
